import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useMemo, useState } from 'react';
import { Spin } from 'antd';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import { getOlogies } from '../SchoolGradeOlogyApis';

const Wrapper = styled.div``;

const OlogiesWrapper = styled.div`
  display: grid;
  grid-template-columns: ${({cols}) => `repeat(${cols}, minmax(0, 1fr))`};
  gap: 8px;
`;

const OlogyButton = styled.a`
  text-align: left;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

function Ologies({ gradeId }) {
  const [ologies, setOlogies] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getOlogies(gradeId)
      .then((data) => {
        setOlogies(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const numOfCols = useMemo(() => {
    return Math.ceil(ologies.length / 12);
  }, [ologies]);

  return (
    <Wrapper>
      <OlogiesWrapper cols={numOfCols} className="overflow-auto sm:flex-wrap sm:overflow-hidden">
        {loading ? (
          <Spin />
        ) : (
          ologies.map((o) => (
            <OlogyButton title={o.OlogyName} href={`/module/${o.ModuleDisplay1 || 'book-ology'}?id=${o.OlogyID}`}>
              <FontAwesomeIcon icon={faCaretRight} />{' '}
               {o.OlogyName}
            </OlogyButton>
          ))
        )}
      </OlogiesWrapper>
    </Wrapper>
  );
}

export default Ologies;
